import { Market, Vector, AuthIcon, MessageIcon } from '../../Icons';
import { MarkedElementInterface } from '../../lib/common-interfaces';

export const MarkedItemIcons: MarkedElementInterface = {
  market: Market,
  vector: Vector,
  auth: AuthIcon,
  mail: MessageIcon,
};
